export default {
  title: 'Stock',
  'menu.transferItems': 'Transfer items',
  'table.name': 'Name',
  'table.availableAmount': 'Available amount',
  'table.totalAmount': 'Total amount',
  'table.active': 'Active',
  'table.status.critical': 'Critical',
  'table.status.warning': 'Warning',
  'table.status.normal': 'Normal',
  'table.status.noValues': 'No critical or warning volume values registered',
  'actions.viewDetails': 'View details',
  'actions.edit': 'Edit',
  'actions.transfers': 'Transfers',
  'actions.qrCode': 'QR Code',
  'actions.remove': 'Remove',
  'tabs.details': 'Details',
  'tabs.transfersHistory': 'Transfers history',
  'tabs.userStocks': 'Stock by user',
  'tabs.placeStocks': 'Stock by place',
  'tabs.qrCodes': 'QR Codes',
  'transfersHistory.title': 'Transfers history',
  'transfersHistory.table.date': 'Date',
  'transfersHistory.table.doneBy': 'Done by',
  'transfersHistory.table.operationType': 'Operation type',
  'transfersHistory.table.amount': 'Amount',
  item: 'Item',
  'transfersHistory.table.origin': 'Origin',
  'transfersHistory.table.destination': 'Destination',
  'transfersHistory.operation.addToGeneral': 'Add to general stock',
  'transfersHistory.operation.removeGeneralStock': 'Remove from general stock',
  'transfersHistory.operation.setGeneralStock': 'Adjust total general stock value',
  'transfersHistory.operation.transferFromGeneralToUser': 'Transfer from general stock to user',
  'transfersHistory.operation.transferFromUserToGeneral': 'Transfer from user to general stock',
  'transfersHistory.operation.transferFromGeneralToPlace': 'Transfer from general stock to place',
  'transfersHistory.operation.transferFromPlaceToGeneral': 'Transfer from place to general stock',
  'transfersHistory.operation.selfUse': 'User use',
  'transfersHistory.generalStock': 'General stock',
  'userStocks.title': 'Transfers history',
  'userStocks.table.user': 'User',
  'userStocks.table.amount': 'Amount',
  'placeStocks.title': 'Transfers history',
  'placeStocks.table.place': 'Place',
  'placeStocks.table.amount': 'Amount',
  'details.availableAmount': 'Available amount',
  'details.totalAmount': 'Total amount',
  'details.status': 'Status',
  'details.status.active': 'Active',
  'details.status.inactive': 'Inactive',
  'qrcodes.noQrCode': 'No QR Code found',
  'operationType.addToGeneral': 'Add to general stock',
  'operationType.removeGeneralStock': 'Remove from general stock',
  'operationType.setGeneralStock': 'Adjust total general stock value',
  'operationType.transferFromGeneralToUser': 'Transfer from general stock to user',
  'operationType.transferFromUserToGeneral': 'Transfer from user to general stock',
  'operationType.transferFromGeneralToPlace': 'Transfer from general stock to place',
  'operationType.transferFromPlaceToGeneral': 'Transfer from place to general stock',
  'operationType.selfUse': 'Self use'
}
